<div class="file-storage-management-page">
  <p-toast></p-toast>

  <msf-list-page-wrapper [leftSize]="'3'" [rightSize]="'9'">
    <!-- Left: Buckets sidebar -->
    <div left #left>
      <div class="sidebar">
        <div class="sidebar-header">
          <div class="title">{{ 'Buckets' | translate }}</div>
          <button pButton type="button" icon="pi pi-refresh" class="p-button-text" (click)="refreshBuckets()" [pTooltip]="'Refresh' | translate"></button>
        </div>
        <div class="sidebar-filter">
          <input [(ngModel)]="bucketFilter" (input)="applyBucketFilter()" placeholder="{{ 'Filter buckets' | translate }}" />
        </div>
        <div class="bucket-list">
          <div *ngFor="let b of filteredBuckets"
               class="bucket-item"
               [class.active]="b === selectedBucket"
               (click)="selectBucket(b)">
            {{ b }}
          </div>
        </div>
        <div class="sidebar-info" *ngIf="selectedBucket">
          <div class="info-row"><span>{{ 'Selected bucket' | translate }}:</span><b>{{ selectedBucket }}</b></div>
          <div class="info-row"><span>{{ 'Files' | translate }}:</span><b>{{ files?.length || 0 }}</b></div>
        </div>
      </div>
    </div>

    <!-- Right: Main content -->
    <div right #right>
      <div class="top-header">
        <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-plain back-button" routerLink="/admin"></button>
        <h1 class="page-title">{{ 'File Storage Management' | translate }}</h1>
      </div>

      <div class="page-content">
        <div class="table-section">
          <div class="field-list-table-container">
            <app-data-table
              [columns]="tableColumns"
              [data]="files"
              [config]="tableConfig"
              [totalRecords]="totalRecords"
              [loading]="loading"
              (onRowSelect)="onRowSelect($event)"
              (onRowUnselect)="onRowUnselect($event)"
              (onPage)="onPageChange($event)"
              (onSort)="onSort($event)"
              (onFilter)="onFilter($event)"
              (onSelectAllChange)="onSelectAllChange($event)">
            </app-data-table>
          </div>
        </div>
      </div>

      <ng-template #actionDownloadTemplate let-row>
          <button pButton type="button"
                  icon="pi pi-download"
                  class="p-button-rounded p-button-text download-action-button"
                  [pTooltip]="'Download' | translate"
                  tooltipPosition="top"
                  (click)="downloadFileById(row.id)">
          </button>
        </ng-template>

        <ng-template #userTemplate let-row>
          <span>{{ getUser(row.createUser)?.email || '' }}</span>
        </ng-template>

        <ng-template #dateTemplate let-row>
          <span>{{ formatDate(row.createAt) }}</span>
        </ng-template>

        <ng-template #idTemplate let-row>
          <span class="file-id-clickable"
                (click)="copyFileId(row.id)"
                [pTooltip]="'Click to copy' | translate"
                tooltipPosition="top">
            {{ row.id }}
          </span>
    </ng-template>
  </div>
  </msf-list-page-wrapper>

  <p-dialog [(visible)]="showFileInfoModal" [modal]="true" [style]="{width: '480px'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      {{ 'File info' | translate }}
    </ng-template>
    <ng-template pTemplate="content">
      <div *ngIf="selectedFile as f" class="file-info">
        <div><b>{{ 'ID' | translate }}:</b>
          <span class="file-id-clickable"
                (click)="copyFileId(f.id)"
                [pTooltip]="'Click to copy' | translate"
                tooltipPosition="top">
            {{ f.id }}
          </span>
        </div>
        <div><b>{{ 'Bucket' | translate }}:</b> {{ f.fileStorageBacket }}</div>
        <div><b>{{ 'Path' | translate }}:</b> {{ f.fileStoragePath }}</div>
        <div><b>{{ 'Owner' | translate }}:</b> {{ f.ownerId }}</div>
        <div><b>{{ 'Type' | translate }}:</b> {{ f.ownerTypeFullName }}</div>
        <div><b>{{ 'Content Type' | translate }}:</b> {{ f.fileContentTypeName }}</div>
        <div><b>{{ 'Size' | translate }}:</b> {{ f.fileLength || '-' }}</div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton type="button" icon="pi pi-download" (click)="downloadFileById(selectedFile?.id)">
        {{ 'Download' | translate }}
      </button>
      <button pButton type="button" class="p-button-text" (click)="showFileInfoModal=false">{{ 'Close' | translate }}</button>
    </ng-template>
  </p-dialog>
</div>
